import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import api from "components/settings/api";
import { Select, MenuItem } from '@mui/material';
import Layout from "../components/common/Layout";
import SearchBar from "../components/common/SearchBar";
import ResultsList from "../components/search/ResultsList";
import Box from "@mui/material/Box";
import { useRouter } from "next/router";
import { useAuth } from "components/context/auth";
import Button from "@mui/material/Button";
import OutOfCredits from "components/modals/OutOfCredits";
import NewTeam from "components/modals/NewTeam";
import NewPublicPerson from "components/modals/NewPublicPerson";

const findList = [
  // { value: "ALL", label: "All" },
  { value: "Users", label: "Users" },
  // { value: "Skills", label: "Skills"},
  { value: "Teams", label: "Teams" },
  { value: "Organizations", label: "Organizations" },
  { value: "Teambots", label: "Teambots" },
];

const Search = () => {
  // State
  const router = useRouter();
  const [isSearchCentered, setIsSearchCentered] = useState(true);
  const [searchTerm, setSearchTerm] = useState(router.query.term);
  // const [searchOptions, setSearchOptions] = useState(findList?.[0] || { value: '', label: '' });
  const [searchOptions, setSearchOptions] = useState({ value: 'Users', label: 'Users' });

  const [searchUsers, setSearchUsers] = useState(false);
  const [searchTeams, setSearchTeams] = useState(false);
  const [teamResults, setTeamResults] = useState([]);
  const [searchSkills, setSearchSkills] = useState(false)
  const [searchOrganizations, setSearchOrganizations] = useState(false);
  const [usersSkillsResults ,setUsersSkillsResults] = useState([])
  const [placeHolderText, setPlaceHolderText] = useState("Search by user, team or organization")
  const [showCreateTeamModal, setShowCreateTeamModal] = useState(false);
  const [showOutOfCreditsModal, setShowOutOfCreditsModal] = useState(false);
  const [teamCredits, setTeamCredits] = useState(0);
  const [showCreatePersonModal, setShowCreatePersonModal] = useState(false);

  const fetchTeamCredits = async () => {
    try {
      // Fetch credits for user
      const res = await api.get("api/v1/teams/credits");
      // Set teams credit for user
      setTeamCredits(res.data.tokenBalance);
    } catch (err) {
      if (err.message === "Request failed with status code 401") {
        console.error(err);
      } else {
        throw err;
      }
    }
  };

  // This action will toggle a modal on the dashboard page
  const toggleDashboardModal = () => {
    // Check team credits
    if (teamCredits >= 6) {
      setShowCreateTeamModal(!showCreateTeamModal);
    } else {
      setShowOutOfCreditsModal(!showOutOfCreditsModal);
    }
  };
  
  const togglePersonModal = () => {
    setShowCreatePersonModal(!showCreatePersonModal);
  };
  
  const toggleDashboardModalOrganization = () => {
    // Check team credits
    if (teamCredits >= 64) {
      setShowCreateTeamModal(!showCreateTeamModal);
    } else {
      setShowOutOfCreditsModal(!showOutOfCreditsModal);
    }
  };

  const handleChange = (event) => {
    // Update state with input text
    event.preventDefault();
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (searchTerm.trim()) {
      setHasSearched(true);
      // if(!searchSkills){
      searchForTerm(searchTerm);
      // } else{
      //   searchForTermSkills(searchTerm)
      // }
    }
  };

  useEffect(() => {
    const defaultOption = { value: "Users", label: "Users" };
    let selectedOption = defaultOption;

    if (router.query.team) {
      selectedOption = findList.find(option => option.value === "Teams");
    } 
    else if (router.query.skills) {
      selectedOption = findList.find(option => option.value === "Skill");
    }
    else if (router.query.user) {
      selectedOption = findList.find(option => option.value === "Users");
    }
    else if (router.query.organization) {
      selectedOption = findList.find(option => option.value === "Organizations");
    }


    // Only update searchOptions if they are different from the router.query
    if (searchOptions.value !== selectedOption.value) {
      setSearchOptions(selectedOption || defaultOption);
    }

    if (router.query.term && searchTerm !== router.query.term) {
      setSearchTerm(router.query.term);
      searchForTerm(router.query.term);
    }
  }, [router.query]);

  useEffect(() => {
    const query = { ...router.query, term: searchTerm };

    // Reflect the current search option in the URL without reloading the page.
    if (searchOptions.value === 'Users') {
      delete query.team;   
      delete query.skill;
      delete query.organization;
      query.user = true;
    } else if (searchOptions.value === 'Skills') {
      delete query.user;
      delete query.team;
      delete query.organization;
      query.skill = true;
    } else if (searchOptions.value === 'Teams') {
      delete query.user;
      delete query.skill;
      delete query.organization;
      query.team = true;
    } else if (searchOptions.value === 'Organizations') {
      delete query.user;
      delete query.team;
      delete query.skill;
      query.organization = true;
    }
    // Use shallow routing to update the URL without running data fetching methods again.
    router.push({ pathname: '/search', query }, undefined, { shallow: true });
  }, [searchOptions, searchTerm]);

  const handleOnChange = (event) => {
    const value = event.target.value;
    const selectedOption = findList.find(option => option.value === value);
    setHasSearched(true);
    setSearchOptions(selectedOption);
    find(selectedOption);
    switch (value) {
      case "Users":
        setPlaceHolderText("Search for Users by Name")
        break;
      case "Skills":
        setPlaceHolderText("Search for Users By Skill")
        break;
      case "Teams":
        setPlaceHolderText("Search for Teams by Name")
        break;
      case "Organizations":
        setPlaceHolderText("Search for Organizations by Name")
        break;
      default:
        setPlaceHolderText("Search... ")
        break;
    }
  };

  // Results
  const [userResults, setUserResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  
  const [filterOptions, setFilterOptions] = useState({
    users: true,
    skills: true,
    teams: true,
    organizations: true,
  });

  const handleFilterChange = (event) => {
    setFilterOptions({
      ...filterOptions,
      [event.target.name]: event.target.checked,
    });
  };

  const find = (selectedOption) => {
    // If 'ALL' is selected, set all to true
    if (selectedOption.value === "ALL") {
      console.log('all')
      setSearchUsers(true);
      setSearchTeams(true);
      setSearchOrganizations(true);
    } else {
      setSearchSkills(selectedOption.value === "Skills")
      setSearchUsers(selectedOption.value === "Users");
      setSearchTeams(selectedOption.value === "Teams");
      setSearchOrganizations(selectedOption.value === "Organizations");
    }
  };

  const [foundUserResults, setFoundResults] = useState(false);

  const searchForTerm = async (term) => {
    const trimmedTerm = term.trim();
    if (!trimmedTerm) return;

    // setHasSearched(true);

    // Reset search states
    setSearchSkills(false);
    setSearchUsers(false);
    setSearchTeams(false);
    setSearchOrganizations(false);

    // Update state based on searchOptions
    switch (searchOptions.value) {
      case 'Users':
        setSearchUsers(true);
        break;
      case 'Skills':
        setSearchSkills(true);
        break;
      case 'Teams':
        setSearchTeams(true);
        break;
      case 'Organizations':
        setSearchOrganizations(true);
        break;
      default:
        setSearchUsers(true); // Default to users if nothing matches
    }

    // Update the URL and perform the search
    if(!searchSkills){
      const query = { term: trimmedTerm, [searchOptions.value.toLowerCase()]: trimmedTerm, [searchOptions.value.toLowerCase().substring(0, searchOptions.value.length - 1)]: true };
      router.push({ pathname: '/search', query }, undefined, { shallow: true });
    }
  };

  const searchForTermSkills = async (term) => {
    try {
      if (term !== undefined && term !== "") {
        // Clear results
        setUsersSkillsResults([]);
        // Perform search
        const res = await api.get(`/api/v1/search/users/by-skill/${term}`);
        // Check response
        // Show message if no results were found
        if (res.data.length === 0) {
          return null
          } else {
          // Set users results
          setUsersSkillsResults(res.data);
          // console.log(usersSkillsResults)
        }
      }
    } catch (err) {
      throw new Error(err);
    }
  };

  const resetSearch = async () => {
    // Set users results
    setUserResults([]);
    // Set team results
    setTeamResults([]);
    // Set skills results
    setUsersSkillsResults([]);
  }

  useEffect(() => {
    if (userResults?.length > 0) {
      setFoundResults(true);
    } else {
      setFoundResults(false);
    }
  }, [userResults, ]);

  useEffect(() => {
    // Assuming `router.query.filter` holds the filter type (e.g., Users, Teams)
    const filterFromURL = router.query.filter;
    const searchTermFromURL = router.query.term;

    if (filterFromURL) {
      const selectedOption = findList.find(option => option.value === filterFromURL);
      setSearchOptions(selectedOption || { value: 'Users', label: 'Users' });
    }

    if (searchTermFromURL) {
      setSearchTerm(searchTermFromURL);
      searchForTerm(searchTermFromURL);
    }

    fetchTeamCredits()

    if (router.query.term) {
      setHasSearched(true)
    }
  }, []);

  const performSearch = async () => {
    if (router.query.term) {
      try {
        const res = await api.get(`/api/v1/search/all/${router.query.term}`);
        // console.log("API response:", res.data);
        setUserResults(res.data[0] || []);
        setFoundResults(userResults.length > 0)
        const allTeams = [...res.data[1] || [], ...res.data.premiumTeams || []];
        setTeamResults(allTeams);
        // console.log("Updated teamResults state:", teamResults);
        // setHasSearched(true);
        setIsSearchCentered(false);
      } catch (err) {
        console.error("Error during search:", err);
      }
    } else {
      setIsSearchCentered(true);
    }
  };


  useEffect(() => {
    const queryOption = router.query.team ? "Teams" 
                    : router.query.skill ? "Skills" 
                    : router.query.user ? "Users" 
                    : router.query.organization ? "Organizations" 
                    : "ALL";
    const selectedOption = findList.find(option => option.value === queryOption);
    setSearchOptions(selectedOption || findList[0]);

    if (router.query.term) {
      performSearch();
    } else {
      setIsSearchCentered(true);
    }
  }, [router.query]);

  const renderFilters = () => (
    <div className="filters">
      <Select
        labelId="search-filter-label"
        id="search-filter"
        value={searchOptions.value}
        label="Search Filter"
        onChange={handleOnChange}
        sx={{
          height: '56px',
          width: '150px',
          color: 'white',
        }}
      >
        {findList.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );

  const {user:userData}=useAuth()
  const userResultsElement = (
    <div>
      <div className="container--search_results-users">
        <>
          <ResultsList userData={userData} resultsArr={userResults} resultsType="users" />
        </>
      </div>
      {!foundUserResults && (
      
        <div className="container--no_results">
          <h3 className="header header--search_results">
            No users found
          </h3>
        </div>
      )}
    </div>
  );

  const teamResultsElement = (
    <>
      <ResultsList
        resultsType="premium"
        resultsArr={teamResults}
      />
      <ResultsList
        resultsType="basic"
        resultsArr={teamResults}
      />
    </>
  )

  const organizationResultsElement = (
    <ResultsList
      resultsArr={teamResults}
      resultsType="organizations"
    />
  )

  const centeredStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30vh',
  };

  const topStyle = {
    paddingTop: '0px',
  };

  const searchBarStyle = hasSearched ? topStyle : centeredStyle;

return (
  <Layout>
    {showCreateTeamModal && <NewTeam toggleModal={toggleDashboardModal} />}
    {showCreatePersonModal && <NewPublicPerson toggleModal={togglePersonModal} />}
    {showCreateTeamModal && <NewTeam toggleModal={toggleDashboardModal} isOrganization={searchOrganizations}/>}
    {showOutOfCreditsModal && (
      <OutOfCredits toggleModal={searchOrganizations ? toggleDashboardModalOrganization : toggleDashboardModal} />
    )}
    <Box mt={20} mb={10}>
      <div className="container--dashboard_page_wrapper" style={searchBarStyle}>
        <div className="container--search_wrapper">
          <header className="container--search_page_heading">
            <h1 className="header header--search_page_main">
              Find Teammates or a Team to Join
            </h1>
          </header>
          <section className="container--search_bar_wrapper">
            <SearchBar
              linkToPage={false}
              searchForTerm={searchForTerm}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              searchData={findList}
              handleOnChange={handleOnChange}
              searchOptions={searchOptions}
              term={searchTerm}
              resetSearch={resetSearch}
              placeHolderText={placeHolderText}
              />
              {renderFilters()}
          </section>
          
          {searchOrganizations && (
            <div>
              <h2 style={{ marginLeft: "1rem", marginTop: "1rem" }}>
                Organizations
              </h2>
              <section className="container--search_results-teams">
                {organizationResultsElement}
              </section>
                {
                  !teamResults.some(e => e.type === "organization") &&
                  <div className="container--no_results">
                    <h3 className="header header--search_results">No Organizations found</h3>
                  </div>
                }
              
            </div>
          )}
          {
            searchOrganizations && hasSearched &&
              <div className="add-Member-Wrapper">
              <div className="divider"/>
              Don't see the Organization you're looking for? {" "}
              <Button 
                variant="contained"
                color="primary"
                onClick={toggleDashboardModalOrganization}
                aria-label="Add Organization"
                style={{textTransform: 'none'}}>Create an Organization
              </Button>
              </div>
            
          }
          {searchTeams && (
            <div>
              <h2 style={{ marginLeft: "1rem", marginTop: "1rem" }}>Teams</h2>
              <section className="container--search_results-teams">
                {teamResultsElement}
              </section>
                {
                  !(teamResults.some(e => e.type === "basic") || teamResults.some(e => e.type === "premium") )&&
                  <div className="container--no_results">
                    <h3 className="header header--search_results">No teams found</h3>
                  </div>
                }
              
              
            </div>
          )}
          {searchTeams && hasSearched &&
            <div className="add-Member-Wrapper">
            <div className="divider"/>
            Don't see the team you're looking for? {" "}
            <Button 
              variant="contained"
              color="primary"
              onClick={toggleDashboardModal}
              aria-label="Add Team"
              style={{textTransform: 'none'}}>
                Create a Team
            </Button>
            </div>
          }
          {searchUsers && (
            <div>
              <h2 style={{ marginLeft: "1rem", marginTop: "1rem" }}>Users</h2>
              <section className="container--search_page_results-top">
                {userResultsElement}
              </section>
            </div>
          )}
          {searchUsers && hasSearched &&
              <div className="add-Member-Wrapper">
              <div className="divider"/>
              Don't see the person you're looking for? {" "}
              <Button 
                variant="contained"
                color="primary"
                onClick={togglePersonModal}
                aria-label="Add Person"
                style={{textTransform: 'none'}}>
                  Add a Person
            </Button>
            </div>
          }
          {/* {searchSkills && hasSearched && (usersSkillsResults.length > 0) &&(
            <section className="container--search_results-teams">
            <ResultsList
              resultsArr={usersSkillsResults}
              resultsType="skill"
            />
          </section>
          )}
          {
            <div className="add-Member-Wrapper">
            Don't see the person you're looking for? <button className="add-member-button">Add a Person</button>
          </div>
          } */}
        </div>
      </div>
    </Box>
  </Layout>
);
}
Search.propTypes = {
  serverUserData: PropTypes.object,
  resultsArr: PropTypes.array,
};

export default Search;
